<template>
  <div class="h-full flex flex-col bg-white overflow-hidden overflow-hidden shadow py-4">
    <div v-if='product.image' class="bg-contain bg-no-repeat bg-bottom h-40 bg-white block mt-2" :style="`background-image: url('${product.image}');`">
    </div>
    <div class="px-3 py-2 sm:px-3 flex-1">

      <div class="text-xs mt-2 font-bold leading-4 text-gray-600 mb-1">
        {{ product.description }}
      </div>

      <div class="flex text-xs justify-between">
        <div class="leading-4 font-medium">
          <p class="text-gray-500">{{ product.item_code }} | {{ product.brand }} </p>
        </div>

        <div>
          <template v-if="isCustomer">
            <div>
              <span v-if="product.min_order_quantity">Min: {{ product.min_order_quantity }}</span>
              <span v-if="product.max_order_quantity" class="ml-">Max: {{ product.max_order_quantity }} {{ product.base_unit }}</span>
            </div>
          </template>

          <div class="text-right my-1 font-bold" v-if="displayItemPrice">
            <span class="text-sm">MVR</span>
            <span class="text-lg">{{ price }}</span>
          </div>
          <div v-if="isCustomer">
            <span v-if="product.available" class="font-medium">
              <span v-if="unitAvailable" class="inline-flex items-center">
                <span class="block h-2 w-2 rounded-full text-white shadow-solid bg-green-400 mr-2" />Available
              </span>
               <span v-else class="inline-flex items-center">
                <span class="block h-2 w-2 rounded-full text-white shadow-solid bg-red-400 mr-2" />Unit Not Available
              </span>
            </span>
            <span v-else class="font-medium inline-flex items-center">
              <span class="block h-2 w-2 rounded-full text-white shadow-solid bg-gray-400 mr-2" /> Not Available
            </span>
          </div>
          <div v-else>
            <span v-if="product.active && product.available" class="font-medium inline-flex items-center"><span class="block h-2 w-2 rounded-full text-white shadow-solid bg-green-400 mr-2" /> Available</span>
            <span v-if="!product.available && product.active" class="font-medium inline-flex items-center"><span class="block h-2 w-2 rounded-full text-white shadow-solid bg-gray-400 mr-2" /> Not Available</span>
            <span v-if="!product.active" class="font-medium inline-flex items-center"><span class="block h-2 w-2 rounded-full text-white shadow-solid bg-orange-400 mr-2" /> Inactive</span>
          </div>
        </div>

      </div>
    </div>

    <div class="px-3 py-1 sm:px-2 pb-2">
      <ProductControl :enable-product-unit-selection="enableProductUnitSelection" v-if="product.available" :product="product" @unitChange="updateItemUnit"/>
      <div v-else class="text-center text-xs">
        <span class="text-orange-400">Out of stock</span>
      </div>
    </div>
  </div>
</template>

<script>
  import ProductControl from './ProductControl'
  export default {
    name: 'ProductItemCard',
    components: { ProductControl },

    props: {
      product: Object,
      isCustomer: Boolean,
      enableProductUnitSelection: Boolean,
      displayItemPrice : Boolean,
    },

    data() {
      return {
        itemUnit: this.product.default_selling_unit
      }
    },

    computed: {
      price: function() {
        if(this.product.units[this.itemUnit]) {
          return this.product.units[this.itemUnit].price || null
        }
        return null
      },
      unitAvailable: function() {
        if(this.product.units[this.itemUnit]) {
          return this.product.units[this.itemUnit].available > 0;
        }
        return false;
      }
    },

    methods: {
      updateItemUnit(unit) {
        this.itemUnit = unit;
      }
    }
  }
</script>
